"use client";

import React from "react";
import { Phone, Mail, Facebook, Instagram, Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function HelpfulLinksMenu() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-foreground/70 transition-colors hover:text-accent-foreground font-medium">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function MainFooter() {
  const currentYear = new Date().getFullYear();
  const products = [{
    label: "Surgical Staffing",
    path: "/facilities/"
  }, {
    label: "Facility Solutions",
    path: "/facilities/"
  }, {
    label: "Clinician Careers",
    path: "/clinicians/"
  }, {
    label: "Specialty Placement",
    path: "/clinicians/"
  }];
  const staffingSolutions = [{
    label: "Surgical Assistant Staffing"
  }, {
    label: "RNFA Staffing"
  }, {
    label: "First Assist Coverage"
  }, {
    label: "Perioperative Staffing"
  }];
  const locations = [{
    label: "Maryland"
  }, {
    label: "Washington DC"
  }, {
    label: "Virginia"
  }, {
    label: "Nationwide"
  }];
  return <section data-section-id="175488" id="footer" className="bg-muted pt-16 pb-8 border-t border-border !border-none border-1 border-[rgb(123,130,138)]">
      <div className="container mx-auto max-w-7xl px-6">
        <div className="mb-12 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-6 lg:gap-12">
          
          <div className="flex flex-col items-start">
            <img src="https://current-narwhal.10web.cloud/wp-content/uploads/2026/04/Untitled-design-8.png" alt="Atlas Surgical Partners Logo" className="mb-6 h-8" />
            <p className="text-sm leading-relaxed text-foreground/80 font-normal">
              A premium surgical staffing platform connecting elite clinicians with world-class healthcare facilities through clinical precision and SaaS agility.
            </p>
          </div>

          
          <div>
            <h3 className="mb-6 text-lg font-semibold text-accent-foreground tracking-tight">
              Navigation
            </h3>
            <MenuProvider menu_id="16">
              <HelpfulLinksMenu />
            </MenuProvider>
          </div>

          
          

          <div>
            <h3 className="mb-6 text-lg font-semibold text-accent-foreground tracking-tight">
              Surgical Staffing Solutions
            </h3>
            <ul className="space-y-3">
              {staffingSolutions.map((item, i) => <li key={i} data-index={i} className="text-sm text-foreground/70 font-medium">
                  {item.label}
                </li>)}
            </ul>
          </div>

          <div>
            <h3 className="mb-6 text-lg font-semibold text-accent-foreground tracking-tight">
              Locations
            </h3>
            <ul className="space-y-3">
              {locations.map((item, i) => <li key={i} data-index={i} className="text-sm text-foreground/70 font-medium">
                  {item.label}
                </li>)}
            </ul>
          </div>

          
          <div>
            <h3 className="mb-6 text-lg font-semibold text-accent-foreground tracking-tight">
              Get in Touch
            </h3>
            <ul className="space-y-4">
              <li className="flex items-center gap-3"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-phone size-5 shrink-0 text-[#D4AF37]" aria-hidden="true" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:rg7itw" data-ast-start="3209" data-ast-end="3261"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg><span className="text-sm text-foreground/80" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:sew984" data-ast-start="3278" data-ast-end="3378">301-778-8013</span></li>
              <li className="flex items-center gap-3">
                <Mail className="size-5 shrink-0 text-[#D4AF37]" />
                <span className="text-sm text-foreground/80">info@atlassurgicalstaffing.com</span>
              </li>
              <li className="flex items-center gap-3">
                <Link to="/privacy-policy-and-terms-of-service/" className="text-sm text-foreground/70 transition-colors hover:text-accent-foreground font-medium">
                  Privacy Policy
                </Link>
              </li>
              <li className="flex items-center gap-3">
                <Link to="/terms-of-service/" className="text-sm text-foreground/70 transition-colors hover:text-accent-foreground font-medium">
                  Terms of Service
                </Link>
              </li>
              <li className="flex items-center gap-3">
                <div className="flex gap-4 pt-2">
                  <a href="https://www.facebook.com/profile.php?id=61572075250200" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-accent-foreground">
                    <Facebook className="size-5 shrink-0 text-[#D4AF37]" />
                  </a>
                  <a href="https://www.linkedin.com/company/atlas-surgical-staffing/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-accent-foreground">
                    <Linkedin className="size-5 shrink-0 text-[#D4AF37]" />
                  </a>
                  <a href="https://www.instagram.com/atlassurgicalpartners/" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-accent-foreground">
                    <Instagram className="size-5 shrink-0 text-[#D4AF37]" />
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        
        <Separator className="mb-6 bg-border/40" />
        <div className="flex justify-center">
          <p className="font-sans text-[12px] text-foreground/60 tracking-wider">
            © {currentYear} Atlas Surgical Partners. All rights reserved.
          </p>
        </div>
      </div>
    </section>;
}